<brd-hero-image></brd-hero-image>
<brd-maintenance-alert></brd-maintenance-alert>
<div class="section-container">
  <div class="title">
    <h2>Board Demo Portal Support Page</h2>
  </div>
  <div class="info-container">
    <div>
      Welcome to our support request page. Please fill out the following form to submit your request. We will get back to you as soon as
      possible.
    </div>
    <div>To help us assist you more effectively, please keep in mind the following:</div>
    <strong>🔍 What happens after you submit your request?</strong>
    <div>Depending on the nature of your request, different teams will be involved to ensure the most appropriate and timely support:</div>
    <ul>
      <li>
        <strong>Cloud or Infrastructure Issues:</strong><br />
        <div>
          These requests are treated by the Cloud team with high priority. For blocking issues, we provide 24x5 coverage (during working
          days) to ensure a timely response.
        </div>
      </li>
      <li>
        <strong>Demo Asset Bug or Feedback:</strong><br />
        <div>These requests are handled by the Demo Portal team <strong>on a best-effort basis.</strong></div>
        <div>If the issue is blocking, we will provide workaround suggestions as soon as possible.</div>
        <div>Otherwise, bugs and feedback will be added to our backlog for evaluation and resolution based on priority and complexity.</div>
      </li>
    </ul>
    <div>
      <strong>Requests from Partners</strong>: our <strong>Partner Success Managers</strong> will be also engaged to ensure smooth
      coordination and follow-up. In general, responses will be directed to the person who submitted the request.
    </div>
    <strong>📝 Help us help you faster</strong>
    <div>
      When filling in the description field, please include as many relevant details as possible. The more context we have, the quicker we
      can diagnose and resolve the issue. Consider including also:
    </div>
    <ul>
      <li>date/time when the issue started occurring</li>
      <li>issue severity/criticality</li>
      <li>detailed description of the issue</li>
      <li>if a workaround exists or not</li>
      <li>instance name and URL (if applicable)</li>
      <li>steps to reproduce (if applicable)</li>
      <li>impacted screen or feature - e.g., dataview name, unclear calculation, non-working component (if applicable)</li>
      <li>error messages (if applicable)</li>
    </ul>
  </div>
  <form [formGroup]="supportFormGroup" class="support-container">
    <dx-select-box
      formControlName="requestType"
      label="Type of issue *"
      [items]="issueTypeOptions"
      displayExpr="label"
      valueExpr="value"
      labelMode="floating"
      stylingMode="outlined"
    ></dx-select-box>
    <dx-text-area
      formControlName="description"
      label="Describe your issue *"
      labelMode="floating"
      stylingMode="outlined"
      [inputAttr]="{ rows: 10 }"
    ></dx-text-area>
    <brd-button [disabled]="!supportFormGroup.valid" color="primary" text="submit" (clickEvent)="onSubmit()"></brd-button>
    <!-- <div>
      <b>IF YOU ARE A BOARD EMPLOYEE</b>, and if
      <ul>
        <li>
          you find an infrastructural issue with the Demo Portal or you have problem in accessing it, please open a ticket on Salesforce;
        </li>
        <li>
          you find any other sort of issues with the Demo Portal, please contact the support team
          <a href="mailto:demoportal@board.com">demoportal&#64;board.com</a>: we will help you in triaging the request.
        </li>
      </ul>
    </div>
    <div>
      <b>IF YOU ARE A PARTNER</b>, and if you find any sort of issues with the Demo Portal, please fill the following
      <a href="https://app.smartsheet.com/b/form/5434a65e18a44c5284c6526a31b25ee1" target="_blank">form</a>; your Partner Success Manager
      will help you in triaging the request by:
      <ul>
        <li>opening a Cloud ticket (on Salesforce) in case of <b>Cloud/Infrastructure Issue;</b></li>
        <li>
          sending an email to
          <a href="mailto:demoportal@board.com">demoportal&#64;board.com</a> with the Partner in CC and the Demo Portal Team in case of a
          <b>Demo Asset Issue, a Bug or an Idea.</b>
        </li>
      </ul>
    </div> -->
  </form>
</div>
